/*
 * State Status Values
 */
export const STATE_AVAILABLE = 'available';
export const STATE_CALCULATING = 'calculating';
export const STATE_CALC_SCHEDULED = 'calc_scheduled';
export const STATE_ERROR = 'error';
export const STATE_NEEDS_REVIEW = 'needs_review';
